import { Link, useNavigate } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { navLinks, siteInfo } from "@/mocks/site";
import { scrollToSubscribe } from "@/utils/subscribeNav";

export default function SiteFooter() {
  const navigate = useNavigate();
  return (
    <footer className="mt-20 bg-primary-950 text-background-100">
      <div className="mx-auto grid w-full max-w-shell grid-cols-1 gap-10 px-4 py-14 md:px-6 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
              <i className="ri-megaphone-fill text-lg" aria-hidden="true" />
            </span>
            <h2 className="font-heading text-xl font-black tracking-tight text-background-50">
              爆料在线
            </h2>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200/80">
            {siteInfo.intro}
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            {["独家猛料", "内幕调查", "微八卦", "首发快讯"].map((tag) => (
              <span
                key={tag}
                className="rounded-full border border-background-100/20 px-3 py-1 text-xs text-background-200/90"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>

        <div className="lg:col-span-2">
          <h3 className="font-heading text-sm font-bold text-background-50">快速导航</h3>
          <ul className="mt-4 space-y-2.5">
            {navLinks.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="cursor-pointer text-sm text-background-200/80 hover:text-accent-300">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-2">
          <h3 className="font-heading text-sm font-bold text-background-50">内容栏目</h3>
          <ul className="mt-4 space-y-2.5">
            {categories.map((item) => (
              <li key={item.slug}>
                <Link
                  to={`/category/${item.slug}`}
                  className="cursor-pointer text-sm text-background-200/80 hover:text-accent-300"
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <h3 className="font-heading text-sm font-bold text-background-50">线索与联系</h3>
          <ul className="mt-4 space-y-3 text-sm text-background-200/80">
            <li className="flex items-start gap-2">
              <span className="mt-0.5 flex h-5 w-5 items-center justify-center">
                <i className="ri-mail-send-line text-accent-400" aria-hidden="true" />
              </span>
              <span>
                爆料线索：
                <a href="mailto:tips@baoliao-online.example.com" className="ml-1 cursor-pointer text-accent-300 hover:underline">
                  {siteInfo.tipEmail}
                </a>
              </span>
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-0.5 flex h-5 w-5 items-center justify-center">
                <i className="ri-mail-line text-accent-400" aria-hidden="true" />
              </span>
              <span>
                合作与更正：
                <a href="mailto:contact@baoliao-online.example.com" className="ml-1 cursor-pointer text-accent-300 hover:underline">
                  {siteInfo.email}
                </a>
              </span>
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-0.5 flex h-5 w-5 items-center justify-center">
                <i className="ri-time-line text-accent-400" aria-hidden="true" />
              </span>
              <span>编辑部值守时间：每日 09:00 - 次日 01:00</span>
            </li>
          </ul>
          <a
            href="#subscribe"
            onClick={(event) => {
              event.preventDefault();
              scrollToSubscribe(navigate);
            }}
            className="mt-5 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-semibold text-primary-950 hover:bg-accent-400"
          >
            <i className="ri-notification-3-line" aria-hidden="true" />
            订阅独家推送
          </a>
        </div>
      </div>

      <div className="border-t border-background-100/15">
        <div className="mx-auto flex w-full max-w-shell flex-col gap-2 px-4 py-5 text-xs text-background-200/60 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>© {new Date().getFullYear()} 爆料在线 · 独家内容编辑部</p>
          <p className="flex flex-wrap gap-x-4 gap-y-1">
            <span>本站内容仅供信息参考，不构成任何事实认定</span>
            <span>先核实，后发布</span>
          </p>
        </div>
      </div>
    </footer>
  );
}